var map = {
	"./AreaPage.jsx": 3660,
	"./CityPage.jsx": 3292,
	"./CountriesPage.jsx": 2590,
	"./CountryPage.jsx": 597,
	"./HomeRedirect.jsx": 9973,
	"./NotFoundPage.jsx": 7153,
	"./RestaurantPage.jsx": 4538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6023;